import {_, React, observer, observable, useLocalStore} from '@api'
import {} from '@stores'
import {useCardFieldStore} from '@modules'
import * as css from './NestedItemFieldToolbarButtons.css'

/// region Store

export class NestedItemFieldToolbarButtonsStore {
  constructor() {
  }

  @observable foo = false
}

export const NestedItemFieldToolbarButtonsStoreContext = React.createContext<NestedItemFieldToolbarButtonsStore>(null)
export const useNestedItemFieldToolbarButtonsStore = () => React.useContext(NestedItemFieldToolbarButtonsStoreContext)

/// endregion

/// region Components

export const NestedItemFieldToolbarButtons = observer(function NestedItemFieldToolbarButtons() {
  const fieldStore = useCardFieldStore(),
    store = useLocalStore(() => new NestedItemFieldToolbarButtonsStore())

  if (!fieldStore.isFieldNested) return null

  return (
    <NestedItemFieldToolbarButtonsStoreContext.Provider value={store}>
      <div className={css.root}>
      </div>
    </NestedItemFieldToolbarButtonsStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/product/productCard/components/BuilderCard/NestedItemFieldToolbarButtons.tsx